'use client'

import '@/styles/globals.css'

// Last-resort boundary: replaces the root layout, so it must ship its own
// <html>/<body>. Everything the root layout provides (lang, dark class, fonts,
// providers) is gone here by definition — hence the inline colours, which keep
// the page readable even if the stylesheet is what failed to load.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="pl" className="dark" style={{ colorScheme: 'dark' }}>
      <body
        style={{
          margin: 0,
          minHeight: '100svh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
          padding: '6rem 1.5rem',
          textAlign: 'center',
          backgroundColor: 'oklch(0.141 0.005 285.823)',
          color: 'oklch(0.985 0 0)',
          fontFamily:
            'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          WebkitFontSmoothing: 'antialiased',
        }}
      >
        <h1 style={{ margin: 0, fontSize: '1.125rem', fontWeight: 500 }}>Coś poszło nie tak</h1>
        <p
          style={{
            margin: 0,
            maxWidth: '65ch',
            fontSize: '0.875rem',
            color: 'oklch(0.705 0.015 286.067)',
          }}
        >
          Nie udało się wczytać strony. Spróbuj ponownie za chwilę.
        </p>
        {error.digest ? (
          <p
            style={{
              margin: 0,
              fontSize: '0.75rem',
              fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
              color: 'oklch(0.705 0.015 286.067)',
            }}
          >
            ID: {error.digest}
          </p>
        ) : null}
        <div
          style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.75rem' }}
        >
          <button
            type="button"
            onClick={reset}
            style={{
              borderRadius: '9999px',
              border: '1px solid oklch(0.705 0.015 286.067 / 40%)',
              background: 'transparent',
              color: 'inherit',
              padding: '0.5rem 1.25rem',
              fontSize: '0.875rem',
              cursor: 'pointer',
            }}
          >
            Spróbuj ponownie
          </button>
          {/* Plain anchor, not next/link: after a root-level crash a full document
              load is the only reliable way back. */}
          <a
            href="/"
            style={{
              borderRadius: '9999px',
              border: '1px solid oklch(0.705 0.015 286.067 / 40%)',
              padding: '0.5rem 1.25rem',
              fontSize: '0.875rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Wróć na stronę główną
          </a>
        </div>
      </body>
    </html>
  )
}
